import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CredentialsComponent } from './credentials.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: CredentialsComponent
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./add-credentials/add-credentials.component').then((c) => c.AddCredentialsComponent),
  },
  {
    path: 'edit/:id',
    loadComponent: () =>
      import('./add-credentials/add-credentials.component').then((c) => c.AddCredentialsComponent),
  },
  ];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CredentialsRoutingModule { }
